export function checkSupportedFormatFunction(file: any, acceptedFormatList: string[]): boolean {
  let type = file.type;
  if (type === '') type = getFileType(file.name);

  return acceptedFormatList?.length === 0
    ? true
    : type === '' || type === null || type === undefined
    ? false
    : acceptedFormatList?.length
    ? acceptedFormatList?.includes(type)
    : true;
}

const getFileType = (fileName: string): string => {
  const extension = fileName.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'bmp':
      return 'image/bmp';
    case 'gif':
      return 'image/gif';
    case 'ico':
      return 'image/x-icon';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'wbmp':
      return 'image/vnd.wap.wbmp';
    case 'webp':
      return 'image/webp';

    case 'pkm':
      return 'image/x-etc1-pkm';
    case 'ktx':
      return 'image/ktx';
    case 'astc':
      return 'image/astc';
    case 'dng':
      return 'image/x-adobe-dng';
    case 'heic':
      return 'image/heic';
    case 'heif':
      return 'image/heif';
    case 'avif':
      return 'image/avif';

    case 'svg':
      return 'image/svg+xml';
    default:
      return '';
  }
};
